"use client";
import type { ReactElement } from "react";
import { AnimatePresence, motion, type MotionValue } from "framer-motion";
import { Cscrollable } from "../Cscrollable";
import { BATCH_MAX_HEIGHT, EVENT_CARD_WIDTH, } from "./timeline-constants";
import type { TimelinePeriod as TimelinePeriodType } from "./timeline-types";
import type { TimelineEventHoverPayload } from "./timeline-period-types";
import { SCROLL_DIRECTION_VERTICAL, type TimelineEventStackStyle, } from "./timeline-period-selectors";
import { TimelineEventCard } from "./TimelineEventCard";
export interface TimelineEventStackProps {
    cardTextColor: MotionValue<string>;
    isAbove: boolean;
    isVisible: boolean;
    onHoverEvent: (payload: TimelineEventHoverPayload | null) => void;
    period: TimelinePeriodType;
    stackStyle: TimelineEventStackStyle;
}
export function TimelineEventStack({ cardTextColor, isAbove, isVisible, onHoverEvent, period, stackStyle, }: TimelineEventStackProps): ReactElement {
    return (
      <AnimatePresence>
        {isVisible && (<motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.2, ease: "easeOut" }} style={{
                position: "absolute",
                inset: 0,
                zIndex: 2,
            }}>
            <motion.div style={{
                position: "absolute",
                left: "50%",
                width: EVENT_CARD_WIDTH,
                marginLeft: -EVENT_CARD_WIDTH / 2,
                maxHeight: BATCH_MAX_HEIGHT,
                ...stackStyle,
            }}>
              <Cscrollable dataElScope="Cmarkdowntimeline/TimelineEventStack" direction={SCROLL_DIRECTION_VERTICAL} fadeSize={10} verticalFadeTopSize={12} verticalFadeBottomSize={14} verticalFadeMiddleOpacity={0.9} firstItemSpacing={0} style={{
                width: "100%",
                maxHeight: BATCH_MAX_HEIGHT,
                display: "flex",
                flexDirection: stackStyle.flexDirection,
            }}>
                {period.events.map((timelineEvent) => (<TimelineEventCard key={`${period.globalIndex}-event-${timelineEvent.eventIndex}`} cardTextColor={cardTextColor} eventCount={period.events.length} isAbove={isAbove} onHoverEvent={onHoverEvent} periodGlobalIndex={period.globalIndex} periodLabel={period.label} timelineEvent={timelineEvent}/>))}
              </Cscrollable>
            </motion.div>
          </motion.div>)}
      </AnimatePresence>
    );
}
